import logUtil from 'utils/log'
import React from 'react'
import useSelector from 'hooks/use-selector'
import ProductPageSquadBadge from 'pages/Product/containers/SquadBadge/index'
import hasBadgeRatingsByProductIdSquadSelector from 'modules/squad/redux/selectors/has-badge-ratings-by-product-id'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import './index.css'

const ANALYTICS_EVENT = {
  SHOW_PRODUCT_SQUAD_BADGE_IN_QUICK_SHOP: 'SHOW_PRODUCT_SQUAD_BADGE_IN_QUICK_SHOP',
  SHOW_PRODUCT_SQUAD_BADGE_MEMBERS_IN_QUICK_SHOP: 'SHOW_PRODUCT_SQUAD_BADGE_MEMBERS_IN_QUICK_SHOP'
}

const QuickShopProductSidebarSquadApprovedBadge = (props) => {
  const { productId } = props

  logUtil('QuickShopProductSidebarSquadApprovedBadge').debug('props=', props)

  const hasBadgeRatings = useSelector(
    hasBadgeRatingsByProductIdSquadSelector(productId)
  )

  const handleUpdate = () => {
    if (!hasBadgeRatings) {
      return
    }
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_PRODUCT_SQUAD_BADGE_IN_QUICK_SHOP)
  }

  React.useEffect(() => {
    handleUpdate()
  }, [hasBadgeRatings])

  const onOpenPicker = () => {
    logUtil('QuickShopProductSidebarSquadApprovedBadge').debug('event=', ANALYTICS_EVENT.SHOW_PRODUCT_SQUAD_BADGE_MEMBERS_IN_QUICK_SHOP)
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_PRODUCT_SQUAD_BADGE_MEMBERS_IN_QUICK_SHOP)
  }

  if (!hasBadgeRatings) {
    return <></>
  }

  return (
    <ProductPageSquadBadge
      shouldLogAnalyticEvents={false}
      onOpenPicker={onOpenPicker}
    />
  )
}

export default QuickShopProductSidebarSquadApprovedBadge
